import { Link } from 'react-router-dom';
import type { FileItem } from '@dpw/shared';
import { api } from '../api';
import { bytes, ext, agoStart } from '../lib/format';

/** Downloads go through the API (session checked), then save in the browser. */
export async function download(f: FileItem) {
  const blob = await api.files.download(f.id);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = f.name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function FileList({ files, showWhere }: { files: FileItem[]; showWhere?: boolean }) {
  if (!files.length) return <div className="empty">No files yet.</div>;
  return (
    <div>
      <div className="fh"><span>File</span><span>{showWhere ? 'Where' : 'Source'}</span><span>Who</span><span>When</span><span /></div>
      {files.map(f => (
        <div className="fr2" key={f.id}>
          <div className="fn"><span className="x">{ext(f.name)}</span><div style={{ minWidth: 0 }}><div className="nm">{f.name}</div><div className="xs mut">{bytes(f.size)}</div></div></div>
          {showWhere ? (f.activityId ? <Link className="fr" to={`/activities/${f.activityId}`}>{f.activityTitle}</Link> : <span className="fr">Track</span>) : <span className="fr">{f.source === 'assistant' ? 'Via the assistant' : 'Upload'}</span>}
          <span className="fr">{f.addedBy?.name.split(' ')[0] ?? ''}</span>
          <span className="fr">{agoStart(f.createdAt)}</span>
          <button className="bt sm" onClick={() => void download(f)}>Open</button>
        </div>
      ))}
    </div>
  );
}
